import React from 'react';
import './ProductItem.scss';

const ProductItem = ({ item, originUrlRedirection, translation, handleProductClick}) => {
    const parseTitle = (title) => {
        const parts = (title || '').split(/(<em>.*?<\/em>)/g);
        return parts.map((part, index) =>
            part.startsWith("<em>") ? (
                <span key={index} className="magenta-color">
                {part.replace(/<\/?em>/g, "")}
            </span>
            ) : (
                part
            )
        );
    };
    return (
        <li
            className="product-item"
            onClick={() => handleProductClick(item)}
        >
            <img
                src={originUrlRedirection + item.imageUrl}
                // alt={item.displayName}
                className="product-image"
            />
            <div className="product-info">
                <p>{item.brand}</p>
                <h5>{parseTitle(item.displayName)}</h5>
            </div>
            <div className="product-price">
                <p className="price-text">{translation('productPrice')}</p>
                {item.initialPrice && item.initialPrice !== item.finalPrice && (
                    <p className="old-price">{item.initialPrice?.toFixed(2)}€</p>
                )}
                <p className="price">{item.finalPrice}€</p>
                {item.programPrice && (
                    <>
                        <p>{translation('withRatePlan')}</p>
                        <p className="price">{item.programPrice?.toFixed(2)}€</p>
                    </>
                )}
            </div>
        </li>
    );
};

export default ProductItem;
